import { Tooltip, TooltipProps, tooltipClasses } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const TriggerRoot = styled('div')<{ $interactive?: boolean; $preserveCase?: boolean }>(
  ({ theme, $interactive, $preserveCase }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
    fontSize: '0.75rem',
    fontWeight: 500,
    color: theme.palette.grey[50] || alpha(theme.palette.text.primary, 0.6),
    textTransform: $preserveCase ? 'none' : 'lowercase',
    cursor: $interactive ? 'pointer' : 'default',
    ...($interactive && {
      '&:hover': {
        color: theme.palette.primary.main,
      },
    }),
  }),
);

export const MenuContainer = styled('div')<{ maxHeight?: number | string }>(
  ({ theme, maxHeight }) => ({
    maxHeight: maxHeight ?? 'auto',
    overflowY: maxHeight ? 'auto' : 'visible',
    minWidth: 238,
    '& .MuiList-root': {
      padding: '0.25rem 0 0',
    },
    '& .MuiMenuItem-root': {
      padding: 0,
      '&:hover': {
        backgroundColor: alpha(theme.palette.grey[50], 0.15),
      },
    },
  }),
);

export const MenuTitle = styled('div')(({ theme }) => ({
  fontWeight: 700,
  fontSize: '0.8125rem',
  padding: '0.5rem 0.5rem 0.625rem',
  color: alpha(theme.palette.primary.darker, 0.7),
  // The default border colour (`divider` — #EAF0F1). This drew `grey[80]` (#A0B7BA),
  // which is `border.dark`, three steps darker than any other rule inside a floating
  // panel: the header separator read heavier than the panel's own edge.
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 260,
    padding: '0.5rem',
    backgroundColor: '#fff',
    borderRadius: 8,
    boxShadow: '0 12px 32px rgba(15, 23, 42, 0.18)',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#fff',
  },
}));
